import { Link } from "react-router-dom";
import { Home, FileText, Library, User, FileBox, LogOut, Shield, ExternalLink } from "lucide-react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "./ui/use-toast";
import { useState, useEffect } from "react";

export function AppSidebar() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        console.log("No active session found");
        return;
      }

      console.log("Current user:", {
        id: session.user.id,
        email: session.user.email,
        user_metadata: session.user.user_metadata,
        app_metadata: session.user.app_metadata
      });

      try {
        // First check if user has any role
        const { data: userRole, error: roleError } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', session.user.id)
          .single();

        if (roleError) {
          console.error("Error fetching user role:", roleError);
          return;
        }

        console.log("User role data:", userRole);
        setIsAdmin(userRole?.role === 'admin');
        console.log("Is admin:", userRole?.role === 'admin');
      } catch (error) {
        console.error("Error checking admin status:", error);
      }
    };

    checkAdminStatus();
  }, []);

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      navigate("/auth");
    } catch (error) {
      console.error("Error signing out:", error);
      toast({
        title: "Error",
        description: "Failed to sign out",
        variant: "destructive",
      });
    }
  };

  return (
    <nav className="flex flex-col h-full">
      <div className="flex flex-col space-y-2 p-4 flex-grow">
        <Link
          to="/"
          className="flex items-center space-x-2 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
        >
          <Home className="h-5 w-5" />
          <span>Home</span>
        </Link>
        <Link
          to="/library"
          className="flex items-center space-x-2 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
        >
          <Library className="h-5 w-5" />
          <span>Default Templates</span>
        </Link>
        <Link
          to="/templates"
          className="flex items-center space-x-2 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
        >
          <FileText className="h-5 w-5" />
          <span>My Templates</span>
        </Link>
        <Link
          to="/documents"
          className="flex items-center space-x-2 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
        >
          <FileBox className="h-5 w-5" />
          <span>My Documents</span>
        </Link>

        <Link
          to="/profile"
          className="flex items-center space-x-2 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
        >
          <User className="h-5 w-5" />
          <span>Profile</span>
        </Link>

        {isAdmin && (
          <Link
            to="/admin"
            className="flex items-center space-x-2 px-4 py-2 text-blue-700 hover:bg-blue-100 rounded-lg"
          >
            <Shield className="h-5 w-5" />
            <span>Admin Dashboard</span>
          </Link>
        )}
      </div>

      <div className="p-4 border-t">
        <Link
          to="/terms"
          className="flex items-center space-x-2 px-4 py-2 text-xs text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg mb-3"
        >
          <ExternalLink className="h-3 w-3" />
          <span>Terms & Conditions</span>
        </Link>
        <Button
          variant="ghost"
          className="w-full justify-start text-red-600 hover:text-red-700 hover:bg-red-50"
          onClick={handleSignOut}
        >
          <LogOut className="h-5 w-5 mr-2" />
          Sign Out
        </Button>
      </div>
    </nav>
  );
}
